import { apiClient } from "api/ApiClient";

/**
 * config情報取得
 */
const getConfig = async (): Promise<any> => {
    try {
        const response = await apiClient.get(`/config`);
        return Promise.resolve(response);
    } catch (e) {
        console.log(`error => `);
        console.log(e);
        return {};
    }
};

export const MyConfigApi = {
    getConfig,
};
